import crypto from 'crypto'

export const generateSignature = (secretKey: string, data: string) => {
  if (!secretKey) return ''

  const hmac = crypto.createHmac('sha256', secretKey)
  hmac.update(data)
  return hmac.digest('hex')
}
